/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type GroupsYouApproveQueryVariables = Types.Exact<{
  [key: string]: never
}>

export type GroupsYouApproveQuery = {
  __typename?: 'Query'
  groups: Array<{
    __typename?: 'BackofficeUserManagementGroup'
    name: string
    displayName: string
  }> | null
}

export const GroupsYouApproveDocument = gql`
    query groupsYouApprove {
  groups: backofficeUserManagementGroups {
    name
    displayName
  }
}
    `

/**
 * __useGroupsYouApproveQuery__
 *
 * To run a query within a React component, call `useGroupsYouApproveQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupsYouApproveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupsYouApproveQuery({
 *   variables: {
 *   },
 * });
 */
export function useGroupsYouApproveQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GroupsYouApproveQuery,
    GroupsYouApproveQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GroupsYouApproveQuery, GroupsYouApproveQueryVariables>(
    GroupsYouApproveDocument,
    options,
  )
}
export function useGroupsYouApproveLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GroupsYouApproveQuery,
    GroupsYouApproveQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GroupsYouApproveQuery,
    GroupsYouApproveQueryVariables
  >(GroupsYouApproveDocument, options)
}
// @ts-ignore
export function useGroupsYouApproveSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GroupsYouApproveQuery,
    GroupsYouApproveQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GroupsYouApproveQuery,
  GroupsYouApproveQueryVariables
>
export function useGroupsYouApproveSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GroupsYouApproveQuery,
        GroupsYouApproveQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GroupsYouApproveQuery | undefined,
  GroupsYouApproveQueryVariables
>
export function useGroupsYouApproveSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GroupsYouApproveQuery,
        GroupsYouApproveQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GroupsYouApproveQuery,
    GroupsYouApproveQueryVariables
  >(GroupsYouApproveDocument, options)
}
export type GroupsYouApproveQueryHookResult = ReturnType<
  typeof useGroupsYouApproveQuery
>
export type GroupsYouApproveLazyQueryHookResult = ReturnType<
  typeof useGroupsYouApproveLazyQuery
>
export type GroupsYouApproveSuspenseQueryHookResult = ReturnType<
  typeof useGroupsYouApproveSuspenseQuery
>
export type GroupsYouApproveQueryResult = Apollo.QueryResult<
  GroupsYouApproveQuery,
  GroupsYouApproveQueryVariables
>
